import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Note } from '../analysis-notes.service';
import { MatTableDataSource } from '@angular/material/table';
import { IConfigurableMatTableConfig } from 'src/app/_interfaces/IConfigurableMatTableConfig';
import { UnixToCentralTimePipe } from 'src/app/_helpers/pipes/unix-to-central-date.pipe';
import moment from "moment";

@Component({
    selector: 'wfdss-rte-existing-notes',
    templateUrl: './rte-existing-notes.component.html',
    styleUrls: ['./rte-existing-notes.component.scss'],
    standalone: false
})
export class RTEExistingNotesComponent implements OnInit {
  tableDs = new MatTableDataSource()
  sortActive = true
  sortDirection = "asc"
  protected _sortingDataAccessor
  protected _columnMetaInformation
  protected _notesList: Note[]
  @Input() set columnMetaInformation(value: IConfigurableMatTableConfig){
    this._columnMetaInformation = value
  } 
  get columnMetaInformation(){
    return this._columnMetaInformation
  }
  @Input() set sortingDataAccessor(value : (data: any, columnTitle: string )=> any){
    this._sortingDataAccessor = value
  } 
  get sortingDataAccessor(){
    return this._sortingDataAccessor
  }
  @Input() set notesList(val: Note[]){
    this._notesList = val
    if(!val){
      this.tableDs.data = []
    } else {
      this.tableDs.data = this.notesList
    }
  }
  get notesList(){
    return this._notesList
  }
  @Output() selectNote = new EventEmitter()
  @Output() deleteNote = new EventEmitter() 
  constructor() { }

  ngOnInit(): void {
  }
  onDeleteNote(row: any){
    this.deleteNote.next(row)
  }
  onRowClick(row: any){
    this.selectNote.next(row)
  }
}
